export default __webpack_public_path__ + "static/media/heart.8da2f5e2.svg";